// extracted by mini-css-extract-plugin
module.exports = {"form_container":"SubscribeToRoyalListPrompt_form_container__5f6A6","form":"SubscribeToRoyalListPrompt_form__hukUG","title":"SubscribeToRoyalListPrompt_title__GeuX1"};